<template>
    <img src="/images/promo/hero-section/busts-in-silhouette.png"
     alt="Busts in silhouette" />
</template>

<script>
export default {};
</script>
